import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
  position: relative;
  z-index: 1000;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;

  font-weight: 600;

  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: DM Sans;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px; /* 133.333% */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-direction: column;
`;

export const RateButton = styled.button`
  display: flex;
  padding: 12px 12px 12px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 44px;

  border-radius: 12px;
  border: ${({ $ratingUp, $ratingDown }) =>
    $ratingUp
      ? "0.5px solid #28D960"
      : $ratingDown
      ? "0.5px solid #FF5959"
      : "0.5px solid #3d3d45"};

  background: #18181b;

  outline: none;

  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#09090b" : "#ffffff")};
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding-inline: 16px;
`;

export const Content = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
  max-height: 90dvh;

  height: calc(90dvh - 122px); /* full viewport height minus footer */
  overflow-y: auto; /* allow scrolling if content is taller */
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${({ $numOfColumns }) => `calc(100% / ${$numOfColumns})`};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: DM Sans;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: DM Sans;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const ModalFooter = styled.div`
  height: 44px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubmitButton = styled.div`
  display: flex;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #18181b;
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
  cursor: pointer;
`;

export const CancelButton = styled.div`
  display: flex;
  height: 40px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const GalleryImage = styled.img`
  border: ${({ $isAdded }) => ($isAdded ? "2px solid #4D9DFF" : "none")};
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  background-color: "#0c0c0e";
`;
